<section class="section-wrapper forth-container-lg">
  <div class="container forth-container p-0">
    <div class="row d-flex align-items-center justify-content-between">
      <div class="forth-section-card forth-section-first-left width-50"
           [ngClass]="{'forth-section-card forth-section-first-left width-46': currentLang === Language.HY}">
        <span class="forth-section-title">{{ 'home-page-content.instant_digital' | translate }}</span>
      </div>

      <div class="forth-section-card forth-section-first-right width-48 forth-section">
        <div class="forth-section-first-right-text col-9 width-62">
          <span class="always-updated-text">{{ 'home-page-content.always_update' | translate }}</span>
          <span class="always-updated-subtext">{{ 'home-page-content.always_update_text' | translate }}</span>
        </div>
        <div class="forth-section-first-right-image">
          <img src="assets/homepage/instant-digital-business-cards/details.png" alt="section 4 details"
               id="section-4-details">
        </div>
      </div>
    </div>

    <div class="row d-flex align-items-center justify-content-between mt-60px">
      <div class="forth-section-card forth-section-second-left d-flex justify-content-end width-48">
        <div class="forth-section-second-left-image">
          <img src="assets/homepage/instant-digital-business-cards/time.png" alt="section 4 time" id="section-4-time">
        </div>
        <div class="forth-section-second-left-text col-8">
          <span class="instant-creation-text"
                [ngClass]="{'instant-creation-text-am': currentLang === Language.HY}">{{ 'home-page-content.instant_creation' | translate }}</span>
          <span class="instant-creation-subtext">{{ 'home-page-content.instant_creation_text' | translate }}</span>
        </div>
      </div>

      <div class="forth-section-card forth-section-second-right d-flex justify-content-end width-48">
        <div class="forth-section-second-left-image">
          <img src="assets/homepage/instant-digital-business-cards/wallet.png" alt="section 4 wallet"
               id="section-4-wallet">
        </div>
        <div class="forth-section-second-right-text col-9">
          <span class="instant-creation-text"
                [ngClass]="{'instant-creation-am': currentLang === Language.HY}">{{ 'home-page-content.wallet_integration' | translate }}</span>
          <span class="instant-creation-subtext "
                [ngClass]="{'instant-creation-subtext-am': currentLang === Language.HY}">{{ 'home-page-content.wallet_integration_text' | translate }}</span>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="section-wrapper-mb forth-container-mb">
  <div class="flex-direction-column">
    <span class="forth-section-title mb-4px"
          [ngClass]="{'forth-section-title-mb mb-4px': currentLang === Language.HY}">{{ 'home-page-content.instant_digital' | translate }}</span>

    <div class="forth-section-card forth-section-first-right width-100">
      <div class="d-flex justify-content-center">
        <span class="always-updated-text align-items-center">{{ 'home-page-content.always_update' | translate }}</span>
      </div>
      <div class="flex-direction-row mt-4">
        <div class="forth-section-first-right-text col-9">
          <span class="always-updated-subtext">{{ 'home-page-content.always_update_text' | translate }}</span>
        </div>
        <div class="forth-section-first-right-image">
          <img src="assets/homepage/instant-digital-business-cards/details-mb.png" alt="section 4 details"
               class="details-mb">
        </div>
      </div>
    </div>

    <div class="forth-section-card forth-section-second-left i-width-100">
      <div class="d-flex justify-content-center">
        <span class="instant-creation-text"
              [ngClass]="{'instant-creation-text margin-top-20': currentLang === Language.HY}">{{ 'home-page-content.instant_creation' | translate }}</span>
      </div>
      <div class="flex-direction-row mt-4">
        <div class="forth-section-first-right-image col-4">
          <img src="assets/homepage/instant-digital-business-cards/time-mb.png" alt="section 4 time" class="time-mb">
        </div>
        <div class="forth-section-first-right-text col-8">
          <span class="instant-creation-subtext">{{ 'home-page-content.instant_creation_text' | translate }}</span>
        </div>
      </div>
    </div>

    <div class="forth-section-card forth-section-first-right i-width-100">
      <div class="d-flex justify-content-center">
        <span class="instant-creation-text"
              [ngClass]="{'instant-creation-text margin-top-39': currentLang === Language.HY}">{{ 'home-page-content.wallet_integration' | translate }}</span>
      </div>
      <div class="flex-direction-row mt-4">
        <div class="forth-section-first-right-text  col-lg-9 col-sm-10 col-8">
          <span class="instant-creation-subtext">{{ 'home-page-content.wallet_integration_text' | translate }}</span>
        </div>
        <div class="forth-section-second-left-image">
          <img src="assets/homepage/instant-digital-business-cards/wallet-mb.png" alt="section 4 wallet"
               class="wallet-mb">
        </div>
      </div>
    </div>

  </div>
</section>
